//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import * as Actions from "./actions"
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { handleGetGradeCategory, handleListSectionAssignment} from "./thunks"
//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const categorySelector = (state) => state.schoologyGradeCategory;
const categoryAllSelector = (state) => state.schoologyAllClassGradeCategory;
const schoologyAssignmentSelector = (state) => state.schoologyAssignment;
//  -- Examples array selector --------




export const useSchoologyGradeCategory = () => {
    const schoologyGradeCategory = useSelector(categorySelector, shallowEqual)
    const schoologyAllClassGradeCategory = useSelector(categoryAllSelector, shallowEqual)
    const currentUser = useCurrentUser()
    const currentClass = useCurrentClass()
    const dispatch = useDispatch()
    const listAllclassSchoologyGradeCategory = async () => {
        if (currentUser&& currentUser.schoologyid && currentUser.role === 'teacher') {
            const all_categories = await dispatch(handleGetGradeCategory(null, currentUser.id, 100))
            if (currentClass && currentClass.sectionId) {
                const catrgories = all_categories[currentClass.sectionId] || []
                dispatch(Actions.setSchoologyGradeCategory(catrgories))
            }
        }
    }

    return [schoologyGradeCategory ,listAllclassSchoologyGradeCategory,  schoologyAllClassGradeCategory , listAllclassSchoologyGradeCategory ];
}

export const useSchoologyAssignment = () => {
    const schoologyAssignment = useSelector(schoologyAssignmentSelector, shallowEqual)
    const currentClass = useCurrentClass()
    const currentUser = useCurrentUser()
    const dispatch = useDispatch()

    const listSchoologyAssignment = async (sectionId) => {
        if (!currentUser || !currentUser.schoologyid) return
        dispatch(handleListSectionAssignment(sectionId ? sectionId : currentClass.sectionId, currentUser.id, 300))
    }
    return [schoologyAssignment, listSchoologyAssignment];
}